import EventEdit from '@/components/ezuro/constants/events/edit/EventEdit.vue'

const defaultFilterValues = {
  name: '',
  action: '',
  flag_before_holidays: ''
};

export default {
  name: 'EventList',
  components: {
    EventEdit
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-events'
    },
    deletePerm: {
      type: String,
      default: 'delete-events'
    },
    basePath: {
      type: String,
      default: 'ezuro/events'
    }
  },
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'id', direction: 'asc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    };
  },
  computed: {
    baseTransParam () {
      return 'event';
    },
    editPermComp () {
      return this.editPerm;
    },
    deletePermComp () {
      return this.editPerm;
    },
    basePathComp () {
      return this.basePath
    },
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('general.item.id'), sortable: false },
        { key: 'name', label: this.$t('general.item.name'), sortable: false, filterKey: 'name' },
        { key: 'action', label: this.$t('event.action'), sortable: false, filterKey: 'action' },
        { key: 'flag_before_holidays', label: this.$t('event.flag_before_holidays'), sortable: false, filterKey: 'flag_before_holidays' }
      ];

      const actions = [];

      if (this.canEdit) {
        actions.push({ label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-sm btn-primary' });
      }

      if (this.canDelete) {
        actions.push({ label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger', ifconfig: { param: 'deleted_at', value: null } });
        actions.push({ label: this.$t('general.actions.enable'), emit: 'restoreItem', bicon: 'clock-history', class: 'btn-sm btn-warning', ifconfig: { param: 'deleted_at', value: null, notCheck: true } });
      }

      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    tableExpandConfig () {
      return null;
    },
    tableFilterConfig () {
      const filters = { };
      filters.name = { type: 'text', label: '', colOnlyFilter: true };
      filters.action = { type: 'text', label: '', colOnlyFilter: true };
      filters.flag_before_holidays = { type: 'text', label: '', colOnlyFilter: true };
      return filters;
    },
    canDelete () {
      return true;
    },
    canEdit () {
      return true;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath(this.basePathComp + '/list?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);

      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }

      return path;
    },
    tableActions () {
      const actions = { download: false };

      if (this.canEdit) {
        actions.add = { title: this.$t('general.actions.add') };
      }

      return actions;
    }
  },
  methods: {
    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },
    getTableData () {
      if (this.basePathComp) {
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }

        this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
        this.loading = true;
        this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, (response) => {
          if (response.data) {
            this.tableItems = response.data;
            this.paging = response.paging;
            this.loading = false;
          }
        });
      }
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('general.item.deleteTitle'), this.$t('general.item.deleteMessage', { name: this.BasicHelper.getTranslation(el.name), code: el.code }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      this.ApiRequest.request(this.basePathComp + '/destroy/' + el.id, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.loading = false;
        } else {
          this.getTableData();
        }
      });
    }
  },
  mounted () {
    if (!this.typeId) {
      this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    } else {
      this.filterValues.type_id = this.typeId;
    }
    this.getTableData();
    this.isMounted = true;
  },
  watch: {
    basePathComp: {
      immediate: true,
      handler (val) {
        if (val) {
          this.isMounted = false;
          if (!this.typeId) {
            this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
          } else {
            this.filterValues.type_id = this.typeId;
          }
          this.getTableData();
          this.isMounted = true;
        }
      }
    }
  }
}
